import { Logger } from '../logging/logger';

export class CustomError extends Error {
  constructor(name: string, message: string) {
    super(message);
    this.name = name;
    Logger.error(message, new Error().stack);
  }
}
